import { z } from "zod";

export const updatePttTokenSchema = z.object({
	apns_ptt_token: z.string().nullable(),
});

export type UpdatePttTokenPayload = z.infer<typeof updatePttTokenSchema>;
